/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `Menu.Subcomponent` filename
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ButtonSecondary from './ButtonSecondary';
import './Modal.Header.scss';
import classnames from 'classnames';
var ModalHeader = function (_a) {
    var children = _a.children, className = _a.className, onBack = _a.onBack, onClose = _a.onClose, shouldCloseOnEscape = _a.shouldCloseOnEscape, subTitle = _a.subTitle, title = _a.title;
    // Manage Escape Keypress
    useEffect(function () {
        var handleEscape = function (event) {
            if (onClose && event.key === 'Escape') {
                onClose();
            }
        };
        if (shouldCloseOnEscape) {
            document.addEventListener('keydown', handleEscape);
        }
        return function () { return document.removeEventListener('keydown', handleEscape); };
    }, [shouldCloseOnEscape, onClose]);
    var legacyHeader = (React.createElement(React.Fragment, null,
        title ? (React.createElement("h1", { className: 'ModalHeader__title u-truncate', "data-testid": 'modalTitle', title: title }, title)) : null,
        subTitle));
    return (React.createElement("div", { className: classnames('ModalHeader', className) },
        React.createElement("div", { className: 'ModalHeader__button' }, onBack ? (React.createElement(ButtonSecondary, { icon: 'arrowLeft', isOutline: false, onClick: onBack, size: 'medium' })) : null),
        React.createElement("div", { className: 'u-textAlign-c u-flexAlign-c u-flexItem-grow' }, children !== null && children !== void 0 ? children : legacyHeader),
        React.createElement("div", { className: 'ModalHeader__button' }, onClose ? (React.createElement(ButtonSecondary, { icon: 'close', isOutline: false, onClick: onClose, size: 'medium' })) : null)));
};
ModalHeader.defaultProps = {
    shouldCloseOnEscape: true
};
ModalHeader.propTypes = {
    className: PropTypes.string,
    onBack: PropTypes.func,
    onClose: PropTypes.func,
    subTitle: PropTypes.node,
    title: PropTypes.string
};
export default ModalHeader;
//# sourceMappingURL=Modal.Header.js.map